
import Vue from "vue";
import axios from "axios";

import helpers from "../inc/helpers";

import TaxLookup from "../data/TaxLookup";

export default Vue.extend({
	name: "CalculateYourTaxesDetail",

	props: {
		parcelId: String,
	},

	data() {
		return {
			isLoading: true as boolean,
			parcelLookup: null as null | TaxLookup,
		};
	},

	mounted() {
		this.getLookup();
	},

	methods: {
		getLookup() {
			this.isLoading = true;

			if (this.parcelId) {
				let endpoint =
					"https://datastore.geaugaconnected.com/wp-json/ds/v1/aa4a47c62c893997a0f7f2d369fa04eb/o/tax-data-lookup/" +
					this.parcelId;

				axios.get(endpoint).then((resp) => {
					if (resp.status === 200 && !!resp.data.data) {
						this.parcelLookup = resp.data.data;
						this.isLoading = false;
					}
				});
			} else {
				this.parcelLookup = null;
				this.isLoading = false;
			}
		},
	},

	filters: {
		formatCurrency(val: string) {
			return helpers.formatCurrency(val);
		},
	},
});
